import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  width: 100%;
  // background-color: #f9f9f9;
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.875)}`}; // 1.25rem

  padding: ${() => `0 ${viewSizeCalculator(1.25)} ${viewSizeCalculator(0.7)} ${viewSizeCalculator(1.25)}`};
 `;
